"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var basicTheme = require("../basicForm/theme.scss");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var LoginForm = /** @class */ (function (_super) {
    tslib_1.__extends(LoginForm, _super);
    function LoginForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onInputChange = function (e) {
            var key = e.target.name;
            var nextState = {};
            nextState[key] = e.target.value;
            _this.setState(nextState);
        };
        _this.onLogin = function (e) {
            e.preventDefault();
            var onLogin = _this.props.onLogin;
            var _a = _this.state, email = _a.email, password = _a.password;
            onLogin(email, password);
        };
        _this.onForgotPasswordClick = function () {
            var onForgotPasswordClick = _this.props.onForgotPasswordClick;
            var email = _this.state.email;
            onForgotPasswordClick(email);
        };
        _this.state = { email: "", password: "" };
        return _this;
    }
    LoginForm.prototype.render = function () {
        var _a = this.props, error = _a.error, errorMessage = _a.errorMessage, title = _a.title, errorCode = _a.errorCode;
        var _b = this.state, email = _b.email, password = _b.password;
        return (React.createElement("div", { className: basicTheme.container },
            React.createElement("div", { className: basicTheme.label }, title),
            React.createElement(ui_1.Form, { onSubmit: this.onLogin, className: basicTheme.form, submitOnEnter: true },
                React.createElement(ui_1.AggregateChangeComponent, { onChange: this.onInputChange },
                    React.createElement(ui_1.FormInput, { value: email, name: "email", className: theme.email, label: "email", required: true, fill: true, type: "text", autoFocus: true }),
                    React.createElement(ui_1.FormInput, { value: password, name: "password", className: theme.password, label: "password", required: true, fill: true, type: "password" })),
                React.createElement(ui_1.Button, { className: basicTheme.button, type: "submit", blue: true, uppercase: true, fill: true, large: true }, "Login")),
            error ? (React.createElement("div", { className: basicTheme.error }, errorMessage ? errorMessage : "Failed to login.")) : null,
            !(errorCode === 996 || errorCode === 999) ?
                React.createElement("div", { className: basicTheme.footerLink },
                    "Forgot your password? ",
                    React.createElement("a", { onClick: this.onForgotPasswordClick }, "Reset"))
                : null,
            React.createElement("div", { className: basicTheme.footerLink },
                "By continuing, you agree to Vidazoo's ",
                React.createElement("a", { href: "https://vidazoo.gitbook.io/vidazoo-legal/terms-and-conditions", target: "_blank" }, "Terms and Conditions"),
                " and ",
                React.createElement("a", { href: "https://vidazoo.gitbook.io/vidazoo-legal/privacy-policy", target: "_blank" }, "Privacy Policy"),
                ".")));
    };
    LoginForm.defaultProps = {
        title: "Great to see you again!"
    };
    return LoginForm;
}(React.Component));
exports.default = LoginForm;
